<template>
  <br />
  <SimpleWizard/>
</template>

<script>
  import api from '@/axios';
  import { useSeguroStore } from '@/stores/seguroStore';
  import SimpleWizard from "./wizardNuevoAsegurado.vue";

  export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],                     
        };
    },
    mounted() {
      this.fetchAsegurado();
    },
    // Importar el componente del wizard
    components: {
      SimpleWizard
    },

    // Navegación y lógica de envío
    methods: {
      async fetchAsegurado() {
          try {
              this.loading = true;
              this.error = null;
              if (this.$route.params.id && this.$route.params.id != 0) {                
                await api.get(`usuarios/detalle/${this.$route.params.id}`);                
                // Cargar otros datos del seguro según sea necesario
              } 
              if (!this.$route.params.id || this.$route.params.id == 0) {                
                const response = await api.get(`usuarios/detalle`);
                this.store.folio = response.data.folio;
              
                // Inicializar otros datos del nuevo seguro según sea necesario
                this.store.endoso = response.data.endoso;
              }
          } catch (err) {
              this.error = 'No se pudo cargar el folio.';
          } finally {
              this.loading = false;
          }
      },
      onSubmit() {
        // Lógica para enviar la solicitud de nuevo seguro
        console.log('Solicitud enviada');
        this.$router.push('/seguros');
      },
      onBack() {
        // Lógica para regresar a la lista de seguros
        console.log('Regresando a la lista de seguros');
        this.$router.push('/seguros');
      }
    }
  };

</script>
